import { put, call } from "redux-saga/effects";

import { BFFAgent } from '../../../../common/BFFAgent';
import {
    GESTION_OPERATIVA_UPDATE_BILLS_FAILURE,
    GESTION_OPERATIVA_UPDATE_BILLS_SUCCESS
} from '../constants';


export function* updateBillsSaga({ data: { id, body} }) {
    try {

        const res = yield call(BFFAgent.Sales.updateBills, id, body)

        if(res) {
            yield put({
                type: GESTION_OPERATIVA_UPDATE_BILLS_SUCCESS,
                data: res
            })
        }

    } catch (err) {
        yield put({
            type: GESTION_OPERATIVA_UPDATE_BILLS_FAILURE,
            data: { error: err },
        })
    }

}



